var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"bz-social-icon",style:({ color: _vm.color, backgroundColor: _vm.background }),domProps:{"innerHTML":_vm._s(_vm.path)}})}
var staticRenderFns = []

export { render, staticRenderFns }